import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useQuestions } from '../stores/useQuestions'; // Filled store
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
import { useApi } from '../services/api'; // FIXED: Import useApi hook for authenticated API
import VideoTest from './VideoTest'; // Import for real interview rendering

export default function InterviewFlow() {
  const { applicationId } = useParams<{ applicationId: string }>(); // Extract real ID from param
  const navigate = useNavigate();
  const { questions, setQuestions } = useQuestions();
  const api = useApi(); // FIXED: Use the hook to get authenticated api instance
  const [showWarning, setShowWarning] = useState(true);
  const [sessionStarted, setSessionStarted] = useState(false);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0); // For multi-question flow

  // Load questions on mount (use real applicationId to fetch job/questions)
  useEffect(() => {
    const loadQuestions = async () => {
      try {
        const res = await api.get(`/applications/${applicationId}/job/questions`); // Updated endpoint: Fetch via application for accuracy
        setQuestions(res.data); // Assume array of {id, text, timeLimit}
      } catch (err) {
        console.error('Load questions failed:', err);
      }
    };
    loadQuestions();
  }, [applicationId, setQuestions, api]); // FIXED: Add api to deps

  const startInterview = () => {
    setShowWarning(false);
    setSessionStarted(true);
    // No navigate; render first question directly
  };

  const handleUploadSuccess = (url: string) => {
    console.log('Uploaded video URL for question:', url);
    // Proceed to next question or complete
    if (currentQuestionIndex < questions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    } else {
      // Complete interview: e.g., api.post('/interviews/complete', { applicationId });
      navigate('/applicant/dashboard'); // Redirect on finish
    }
  };

  if (showWarning) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-surface-page text-txt-primary p-8">
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="bg-surface-card p-8 rounded-input max-w-md text-center">
          <AlertCircle className="w-16 h-16 text-yellow-400 mx-auto mb-4" />
          <p className="mb-6">
            Prepare for an uninterrupted hour with no distractions; this is treated as a live interview and will run until completed. One attempt only.
          </p>
          <button onClick={startInterview} className="bg-brand-600 hover:bg-brand-500 text-txt-primary px-6 py-2 rounded-input font-medium transition-colors">
            Start Now
          </button>
        </motion.div>
      </div>
    );
  }

  if (!sessionStarted || questions.length === 0) {
    return <div className="text-center p-8">Loading interview...</div>;
  }

  const currentQuestion = questions[currentQuestionIndex];

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-surface-page text-txt-primary p-8">
      <VideoTest
        applicationId={applicationId!} // Pass real ID as prop
        question={currentQuestion}
        onUploadSuccess={handleUploadSuccess}
      />
    </div>
  );
}